import { render, staticRenderFns } from "./FolderSendInvalidateAnswersDialog.vue?vue&type=template&id=74c42056&scoped=true"
import script from "./FolderSendInvalidateAnswersDialog.vue?vue&type=script&lang=js"
export * from "./FolderSendInvalidateAnswersDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderSendInvalidateAnswersDialog.vue?vue&type=style&index=0&id=74c42056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c42056",
  null
  
)

export default component.exports